import handler from 'api/handler'

const prefix = '/userAdmin/user'

const methods = {
  update: args => handler({ method: 'put', url: prefix + '/update', args, isFile: true }),
  fetch: args => handler({ method: 'get', url: prefix + '/fetch', args }),
  fetchReferredUsers: args => handler({ method: 'get', url: prefix + '/fetchReferredUsers', args }),
  searchUsers: args => handler({ method: 'get', url: prefix + '/searchUsers', args }),
  planStatus: args => handler({ method: 'post', url: prefix + '/planStatus', args }),
  fetchReferralsByUserRefId: args => handler({ method: 'get', url: prefix + '/fetchReferralsByUserRefId', args }),
  changePin: args => handler({ method: 'put', url: prefix + '/changePin', args }),
  isNewUser: args => handler({ method: 'get', url: prefix + '/isNewUser', args }),
  renewPlan: args => handler({ method: 'post', url: prefix + '/renewPlan', args }),
  fetchPaymentId: args => handler({ method: 'get', url: prefix + '/fetchPaymentId', args })
}

export default methods
